"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ResendLinkModule = /** @class */ (function () {
    function ResendLinkModule() {
    }
    return ResendLinkModule;
}());
exports.ResendLinkModule = ResendLinkModule;
